export const calculateCenter = (mapValue: number, mapWrapperValue: number) => {
  return -(mapValue / 2 - mapWrapperValue / 2);
};
